import type { MenuItemProps, OverflowMenuItems } from '../../types';
import { MenuItem, Menu, MenuSection, IconButton } from '@workramp/ui';

export type OverflowMenuProps = {
  overflowMenuItems?: OverflowMenuItems;
};

const OVERFLOWMENUZINDEX = 1041;

export const CardOverflowMenu = ({ overflowMenuItems }: OverflowMenuProps) => {
  if (Object.keys(overflowMenuItems).length === 0) {
    return null;
  }
  // Create a flattened version of the menu items so we can reference them with a simple index.
  // This involves going over all sections and items and transforming the structure to a single array.
  // Each item in the array is an object that contains the section name, the item itself, and its index within its section.
  const flatItems: { section: string; item: MenuItemProps; index: number }[] = Object.entries(
    overflowMenuItems,
  ).flatMap(([section, items]) =>
    items.map((item, index) => ({
      section,
      item,
      index,
    })),
  );

  return (
    <Menu
      placement="bottom-end"
      onAction={(key: number) => flatItems[key]?.item.action()}
      zIndex={OVERFLOWMENUZINDEX}
      buttonEl={
        <IconButton
          label="More Actions"
          data-testid="overflow-menu-button"
          iconName="overflow-vertical:regular"
          color="secondary"
          variant="text"
        />
      }
    >
      {Object.entries(overflowMenuItems).map(([section, items]) => (
        <MenuSection key={section} aria-label={section}>
          {items.map((item, index) => {
            const flatIndex = flatItems.findIndex(
              (flatItem) => flatItem.section === section && flatItem.index === index,
            );
            return (
              <MenuItem key={flatIndex} color={item.danger ? 'danger' : undefined}>
                {item.label}
              </MenuItem>
            );
          })}
        </MenuSection>
      ))}
    </Menu>
  );
};
